import {combineReducers} from "redux";
import requinsReducer from "./requins/feature"

export default combineReducers({
    requins: requinsReducer,
})

